import { render } from "./InformeTramitacion.vue?vue&type=template&id=5c6a8909&scoped=true"
import script from "./InformeTramitacion.vue?vue&type=script&lang=js"
export * from "./InformeTramitacion.vue?vue&type=script&lang=js"

import "./InformeTramitacion.vue?vue&type=style&index=0&id=5c6a8909&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6a8909"]])

export default __exports__